import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import CategoryPage from "@/pages/CategoryPage";
import StaticPage from "@/pages/StaticPage";
import ScrollToTop from "@/components/ScrollToTop";
import ReviewPopup from "@/components/ReviewPopup";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/collection/:slug" element={<CategoryPage />} />
            <Route path="/pages/:slug" element={<StaticPage />} />
          </Routes>
          <ReviewPopup />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
